import Insights from "./Insights";

function PerformanceInsights() {
  return <Insights type={"GAI"} />;
}

export default PerformanceInsights;
